<ng-template #jsonValue let-value let-copyValue="copyValue">
  @if (getJsonTableEntries(value); as jsonEntries) {
    <div class="wm-device-details-group-content wm-device-details-nested-table">
      @for (jsonEntry of jsonEntries; track jsonEntry.key) {
        <div class="wm-device-details-row">
          <div class="wm-device-details-entry row-desc"><wm-copyable-text [displayText]="jsonEntry.key"></wm-copyable-text></div>
          <div class="wm-device-details-entry" [class.wm-device-details-entry-item]="jsonEntry.isArrayItem">
            <ng-container *ngTemplateOutlet="jsonValue; context: {$implicit: jsonEntry.value}"></ng-container>
          </div>
        </div>
      }
    </div>
  } @else {
    <wm-copyable-text [displayText]="value" [copyText]="copyValue"></wm-copyable-text>
  }
</ng-template>

<div class="wm-device-details">
  <div class="wm-device-details-table">
    @for (group of groups; track group.name) {
      <section class="wm-device-details-group">
        <h3>{{group.name}}</h3>
        <div class="wm-device-details-group-content">
          @for (entry of group.entries; track entry.key + entry.value) {
            <div class="wm-device-details-row">
              <div class="wm-device-details-entry row-desc">
                <wm-copyable-text [displayText]="entry.key"></wm-copyable-text>
              </div>
              <div class="wm-device-details-entry">
                <ng-container *ngTemplateOutlet="jsonValue; context: {$implicit: entry.value, copyValue: entry.copyValue}"></ng-container>
              </div>
            </div>
          }
        </div>
      </section>
    }
  </div>
</div>
